import { useContext } from 'react';

import { getFragmentData, graphql } from '@e-socna/data-layer';

import { FolderContext } from '../../../contexts/FolderContext';

export const MissionForm_FolderConfidentiality_Fragment = graphql(`
  fragment MissionForm_FolderConfidentiality_Fragment on Folder {
    isConfidential
  }
`);

// A mission of a confidential folder gets no Base role from the workflow flags either. Outside
// of a folder (no context), only the mission itself tells.
export const useIsFolderConfidential = (): boolean => {
  const folder = useContext(FolderContext)?.folder;

  return (
    !!folder &&
    getFragmentData(MissionForm_FolderConfidentiality_Fragment, folder)
      .isConfidential
  );
};
